import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//i18n
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import axios from "axios"
import config from "config/config"

const NotificationDropdown = props => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)

  const [notifications, setNotifications] = useState([])
  // Declare a new state variable, which we'll call "menu"

  const fetchNotifications = async () => {
    try {
      console.log("fetching notifications.")

      const notificationResponse = await axios.get(
        `${config.backendUrl}/user/getNotifications?orgId=${activeOrganization.id}`,
        {
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setNotifications(notificationResponse.data.notifications)

      console.log(notificationResponse)
    } catch (err) {
      console.log(err)
    }
  }

  const formatDate = dateString => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }
    return new Date(dateString).toLocaleString(undefined, options)
  }

  const markNotificationAsRead = async id => {
    try {
      const response = await axios.put(
        `${config.backendUrl}/user/markNotificationAsRead`,
        { notificationId: id }, // Sending ID in the body
        {
          headers: { Authorization: `Bearer ${userData.token}` },
        },
      )

      fetchNotifications()
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchNotifications()

    const interval = setInterval(fetchNotifications, 30000)
    return () => clearInterval(interval)
  }, [activeOrganization])
  const [menu, setMenu] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ti-bell"></i>
          {notifications && notifications.length > 0 && (
            <span className="badge text-bg-danger rounded-pill">
              {notifications.length}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h5 className="m-0">
                  {" "}
                  {props.t("Notification")} ({notifications?.length}){" "}
                </h5>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "fit-content" }}>
            {notifications &&
              notifications.length > 0 &&
              notifications.map((notification, index) => (
                <Link
                  to="#"
                  className="text-reset notification-item"
                  key={index}
                  onClick={() => {
                    markNotificationAsRead(notification.id)
                  }}
                >
                  <div className="d-flex">
                    <div className="flex-shrink-0">
                      <div className="avatar-xs me-3">
                        <span
                          className={`avatar-title ${notification.description.includes("Connected") ? "border-success" : notification.description.includes("Disconnected") ? "border-danger" : notification.description.includes("syncing") ? "border-warning" : ""} rounded-circle`}
                        >
                          {notification.description.includes("Connected") && (
                            <i className="mdi mdi-link-variant"></i>
                          )}
                          {notification.description.includes(
                            "Disconnected",
                          ) && <i className="mdi mdi-link-variant-off"></i>}
                          {notification.description.includes("syncing") && (
                            <i className="mdi mdi-timer-sand"></i>
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{notification.description}</h6>
                      <div className="text-muted">
                        <p className="mb-1" style={{ fontSize: "10px" }}>
                          {formatDate(notification.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
